export const loginForm = [
  { type: 1, name: 'email', label: 'Email', required: true },
  { type: 1, name: 'password', label: 'Password', required: true, inputType: 'password' },
];

export const registerForm = [
  { type: 1, name: 'name', label: 'Full Name', required: true },
  { type: 1, name: 'phone', label: 'Phone', required: true },
  { type: 1, name: 'email', label: 'Email', required: true, inputType: 'email' },
  { type: 1, name: 'password', label: 'Password', required: true, inputType: 'password' },
  {
    type: 1,
    name: 'confirmPassword',
    label: 'Confirm Password',
    required: true,
    inputType: 'password',
  },
];

export const userValidateForm = [
  { type: 1, name: 'email', label: 'Email', required: true, disabled: true },
  { type: 1, name: 'otp', label: 'OTP', required: true, inputType: 'number' },
];

export const emailOTPForm = [
  { type: 1, name: 'emailOTP', label: 'Email OTP', required: true, inputType: 'number' },
];

export const billingForm = [
  { type: 1, name: 'firstName', label: 'First Name', required: true },
  { type: 1, name: 'lastName', label: 'Last Name', required: false },
  { type: 1, name: 'email', label: 'Email Address', required: true, inputType: 'email' },
  {
    type: 1,
    name: 'phone',
    label: 'Phone no',
    required: true,
    pretend: '+91',
    inputType: 'number',
  },
  { type: 1, name: 'country', label: 'Country', required: true, disabled: true },
  { type: 1, name: 'Town/City', label: 'Town/City', required: true },
  { type: 1, name: 'state', label: 'State', required: true },
  { type: 1, name: 'zipCode', label: 'Pin Code', required: true, inputType: 'number' },
  { type: 2, name: 'address', label: 'Full Address', required: true },
];

export const validatePhoneNo = [
  {
    type: 1,
    name: 'phone',
    label: 'Phone no',
    required: true,
    pretend: '+91',
    inputType: 'number',
    disabled: true,
  },
  {
    type: 1,
    name: 'otp',
    label: 'OTP',
    required: true,
    inputType: 'number',
  },
];

export const orderNote = [
  {
    type: 2,
    name: 'orderNote',
    label: 'Any special  instruction (optional)',
    placeholder: 'Please enter your order note here....',
    required: false,
  },
];

export const specialCakeNote = [
  {
    type: 1,
    name: 'specialCakeNote',
    label: 'Message or Special Note',
    placeholder: 'Happy Birthday!!!',
    required: false,
  },
];
